var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mx-auto"},[_c('div',{staticClass:"fit"},[_c('ul',{staticClass:"days"},_vm._l((_vm.dayList),function(day,index){return _c('li',{key:day.num,class:{ selected: day.selected },on:{"click":function($event){return _vm.select(index)}}},[_vm._v(" "+_vm._s(day.num)+" ")])}),0)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }